export default [
  {
    custid: "01",
    mobile: "8595843365",
    name: "Harsh Dedhia",
    address: "Mulund, Mumbai",
    email: "harsh@gmail.com",
    
  },
  {
    custid: "02",
    mobile: "8595843365",
    name: "Sumit Jaiswal",
    address: "Nahur, Mumbai",
    email: "sumit@gmail.com",
    
  },
  {
    custid: "03",
    mobile: "8595843365",
    name: "Mohnish Thandassery",
    address: "Thane, Mumbai",
    email: "mohnish@gmail.com",
    
  }
];
